import { SolutionTag, Tag } from '@luminovo/api-contracts';

import { hasSolutionTag } from './hasSolutionTag';

export function isSolutionInNeedOfUpdate({ solutionTags }: { solutionTags: Tag[] }): boolean {
    const isAutoSelected = hasSolutionTag({ solutionTags }, SolutionTag.AutoSelected);
    const isManualOffer = hasSolutionTag({ solutionTags }, SolutionTag.ManualOffer);
    const isOldSolution = hasSolutionTag({ solutionTags }, SolutionTag.Old);
    const isOutdatedSolution = hasSolutionTag({ solutionTags }, SolutionTag.Outdated);
    const isExpiredSolution = hasSolutionTag({ solutionTags }, SolutionTag.Expired);

    return isAutoSelected && !isManualOffer && (isOldSolution || isOutdatedSolution || isExpiredSolution);
}
